import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';

import {InstructionOutro, TitleText, SubtitleText} from './styles';

@inject('store')
@observer
class InstructionOutroComponent extends Component {
  setBackByButton = () => {
    const {
      store: {guidePage}
    } = this.props;

    guidePage.setBackByButton(true);
  };

  render() {
    const {isDesktop, title, subtitle} = this.props;

    return (
      <InstructionOutro isDesktop={isDesktop}>
        <TitleText data-cy="instruction-outro-title" isDesktop={isDesktop}>
          {title}
        </TitleText>
        <SubtitleText isDesktop={isDesktop}>{subtitle}</SubtitleText>
      </InstructionOutro>
    );
  }
}

export default InstructionOutroComponent;
